import { useInfiniteQuery } from 'react-query';
import { getSceneSubscriptions } from '../../services/sceneService';

const PER_PAGE = 50;

export function useGetSceneSubscriptions(
  sceneContentType:
    | 'SceneChat'
    | 'SceneThread'
    | 'SceneEpisode'
    | ('SceneChat' | 'SceneThread' | 'SceneEpisode')[]
) {
  return useInfiniteQuery(
    ['sceneSubscriptions', sceneContentType],
    ({ pageParam = 1 }) =>
      getSceneSubscriptions({
        page: pageParam,
        perPage: PER_PAGE,
        sceneContentType: sceneContentType
      }),
    {
      staleTime: 60 * 1000,
      cacheTime: 5 * 60 * 1000,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      getNextPageParam: (lastPage) => {
        if (lastPage?.meta?.pagination?.currentPage < lastPage?.meta?.pagination?.totalPages) {
          return lastPage?.meta?.pagination?.currentPage + 1;
        }
        return undefined;
      }
    }
  );
}
